import React from "react";
import "../../../src/css/style.css";

const Product = (props) => {
  const { name, image, price, status } = props.product;
  return (
    <div className="col-sm-6 col-xl-3">
      <li>
        <div className="box">
          <a href="">
            <div className="img-box">
              <img src={image} alt="" />
            </div>
            <div className="detail-box">
              <h6>{name}</h6>
              <h6>
                Price:
                <span>{price}</span>
              </h6>
            </div>
            <div className="new">
              <span>{status}</span>
            </div>
          </a>
        </div>
      </li>
    </div>
  );
};

export default Product;
